import {
    OverlayTrigger,
    Tooltip,
    Image,
} from 'react-bootstrap';
import questionMark from '../../images/question_mark.png';

export function InfoHover(label, message) {
    return (
        <span>
            {label} &nbsp;
            <OverlayTrigger
                key={label}
                placement="right"
                overlay={
                    <Tooltip id={label}>
                        {message}
                    </Tooltip>
                }
            >
                <Image className="hover-question" src={questionMark} roundedCircle></Image>
            </OverlayTrigger>
        </span>
    )
}